import { render, staticRenderFns } from "./GenerationTag.vue?vue&type=template&id=637833c4&scoped=true&lang=pug&"
import script from "./GenerationTag.vue?vue&type=script&lang=js&"
export * from "./GenerationTag.vue?vue&type=script&lang=js&"
import style0 from "./GenerationTag.vue?vue&type=style&index=0&id=637833c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637833c4",
  null
  
)

export default component.exports